import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconHelp = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 15 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M7.5 0C3.375 0 0 3.375 0 7.5C0 11.625 3.375 15 7.5 15C11.625 15 15 11.625 15 7.5C15 3.375 11.625 0 7.5 0ZM7.5 9.375C6.46875 9.375 5.625 8.53125 5.625 7.5C5.625 6.46875 6.46875 5.625 7.5 5.625C8.53125 5.625 9.375 6.46875 9.375 7.5C9.375 8.53125 8.53125 9.375 7.5 9.375ZM7.5 1.875C8.34375 1.875 9.1875 2.0625 9.9375 2.4375L8.47875 3.89625C7.76531 3.70219 7.23469 3.70219 6.52031 3.89625L5.0625 2.4375C5.8125 2.0625 6.65625 1.875 7.5 1.875ZM1.875 7.5C1.875 6.65625 2.0625 5.8125 2.4375 5.0625L3.89625 6.52125C3.70219 7.23469 3.70219 7.76531 3.89625 8.47969L2.4375 9.9375C2.0625 9.1875 1.875 8.34375 1.875 7.5ZM7.5 13.125C6.65625 13.125 5.8125 12.9375 5.0625 12.5625L6.52125 11.1038C7.23469 11.2978 7.76531 11.2978 8.47969 11.1038L9.9375 12.5625C9.1875 12.9375 8.34375 13.125 7.5 13.125ZM12.5625 9.9375L11.1038 8.47875C11.2978 7.76531 11.2978 7.23469 11.1038 6.52031L12.5625 5.0625C12.9375 5.8125 13.125 6.65625 13.125 7.5C13.125 8.34375 12.9375 9.1875 12.5625 9.9375Z",
		fill: "currentColor"
	})
});
export default SvgIconHelp;
